import $ from "jquery"
import _ from "underscore"
import EntityStore from "../store/EntityStore"

/**
 * @Deprecated it is obsolete store use instead `taskManagement/common` state of redux
 */
class TaskManagementStore {
    constructor() {
        this.visibleCustomers = []
        this.visibleCustomersFiltered = null
        this.customerProjectNameFilter = null
        this.filterCustomerProjectSelection = null
        this.singleCustomerProjectSelection = null
        this.intersectedCustomerProjectSelection = null
        this.taskStatusFilter = {
            allSelected: true,
            statusIds: [],
            groupTypes: []
        }
        this.taskNameFilter = null
        this.taskIds = new EntityStore()
        this.createdTaskIds = []
        this.allTasksLoaded = false
        this.taskSelection = {
            isAllSelected: false,
            selectedTasks: {},
            count: 0,
            countLoading: false
        }
        this.isNeedApproval = false
        this.taskIdInEdit = null
        this.projectIdInEdit = null
        this.customerIdInEdit = null

        this.editableProjectIds = {}
        this.editableCustomerIds = {}
    }

    getTaskStatusFilter() {
        return this.taskStatusFilter;
    }

    setTaskStatusFilter(taskStatusFilter) {
        this.taskStatusFilter = taskStatusFilter;
        $(this).trigger("taskStatusFilterChange");
    }

    setTaskNameFilter(taskNameFilter) {
        this.taskNameFilter = taskNameFilter;
    }

    getTaskNameFilter() {
        return this.taskNameFilter;
    }

    getTaskIds() {
        return this.taskIds.getAll()
    }

    isAllTasksLoaded() {
        return this.allTasksLoaded
    }

    setAllTasksLoaded(allTasksLoaded) {
        this.allTasksLoaded = allTasksLoaded
    }

    getTaskSelection() {
        return this.taskSelection;
    }

    resetTaskSelection() {
        this.setTaskSelection({
            isAllSelected: false,
            selectedTasks: {},
            countLoading: false,
            count: 0
        })
    }

    setTaskSelection(taskSelectionChange = {}) {
        this.taskSelection = {...this.taskSelection, ...taskSelectionChange};
    }

    isTaskSelectionEmpty() {
        return (!this.taskSelection.isAllSelected) && (_.size(this.taskSelection.selectedTasks) === 0);
    }

    getSelectedTasks() {
        return this.taskSelection.selectedTasks;
    }

    isAllTasksSelected() {
        return this.taskSelection.isAllSelected;
    }

    setPopupInfo(popupInfo) {
        this.popupInfo = popupInfo;
        $(this).trigger("popupInfoReceived")
    }

    appendTaskIds(taskIds) {
        this.taskIds.mergeAll(taskIds);
        $(this).trigger("taskIdsAppend");
    }

    appendCreatedTaskIds(taskIds) {
        this.createdTaskIds.concat(taskIds);
        this.taskIds.mergeAll(taskIds);
        $(this).trigger("createdTaskIdsAppend", [taskIds]);
    }

    replaceCreatedTaskIds(taskIds) {
        this.createdTaskIds = taskIds;
        this.taskIds.mergeAll(taskIds);
    }

    getCreatedTaskIds() {
        return this.createdTaskIds;
    }

    resetCreatedTaskIds() {
        this.createdTaskIds = [];
        $(this).trigger("createdTaskIdsReset");
    }

    replaceTaskIds(taskIds) {
        this.taskIds.replaceAll(taskIds);
        this.resetCreatedTaskIds();
        $(this).trigger("taskIdsReplace");
    }

    removeTasks(taskIds) {
        this.taskIds.removeMany(taskIds);
        this.taskSelection.selectedTasks = _.omit(this.taskSelection.selectedTasks, taskIds);
    }

    setManagerNeedApproval(isNeedApproval) {
        this.isNeedApproval = isNeedApproval;
    }

    getManagerNeedApproval() {
        return this.isNeedApproval;
    }

    setTaskIdInEdit(taskId) {
        this.taskIdInEdit = taskId;
    }

    getTaskIdInEdit() {
        return this.taskIdInEdit;
    }

    getEditableProjectIds() {
        return this.editableProjectIds;
    }

    setEditableProjectIds(editableProjectIds) {
        this.editableProjectIds = editableProjectIds;
    }

    getEditableCustomerIds() {
        return this.editableCustomerIds;
    }

    setEditableCustomerIds(editableCustomerIds) {
        this.editableCustomerIds = editableCustomerIds;
    }
}

export default new TaskManagementStore()


// WEBPACK FOOTER //
// ./web/js/taskManagement/TaskManagementStore.js